import { List, Map } from 'immutable';
import { createSelector } from 'reselect';

const prefix = ['app', 'appraisal', 'property'];

export const recalculateTriggerSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'recalculateTrigger']);
export const dashboardBreadcrumbSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'dashboardBreadcrumb']);
export const sketchLinkSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'sketchLink']);
export const propertysSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'propertyList']);
export const printCardSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'printCard']);
export const propertySelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'property']);
export const propertyFullSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'propertyFull']);
export const propertyFullMassSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'propertyFullMass']);
export const propertyFullMassStateSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'propertyFullMass']).toJS()
    .state;
export const propertyMenulistSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'propertyMenuList']);
export const propertySubpageSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'subpage']);
export const propertyReadyValueSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'propertyValueReady']).toJS()
    .data;
export const propertyReadyValueStateSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'propertyValueReady']).toJS()
    .state;
export const notesSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'notes']);
export const propertyRenderedValueSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'renderedValue']);
export const propertyHeaderSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'header']);
export const propertyAutoCompleteLegalSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'autoCompleteLegal']);
export const propertyAutoCompleteMineralLegalSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'autoCompleteMineralLegal']);
export const propertySummarySelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'summary']);
export const propertyOwnerSummarySelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'ownerSummary']);
export const propertyMobileHomesSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'mobileHomes']);
export const propertyLegalDescriptionSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'legalDescription']);
export const propertyMineralLegalDescriptionSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'mineralLegalDescription']);
export const propertyIdentificationSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'identification']);
export const propertySummaryBPPSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'summaryBPP']);
export const propertyCharacteristicsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'characteristics']);
export const propertyPrimarySitusSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'primarySitus']);
export const propertyAllSitusSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'allSitus']);
export const propertyPrimaryOwnerSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'primaryOwner']);
export const propertyLegalDescriptionFormValuesSelector = (state) =>
  state.getIn(['form', 'appraisalPropertyLegalDescription']);
export const propertyMineralLegalDescriptionFormValuesSelector = (state) =>
  state.getIn(['form', 'appraisalPropertyMineralLegalDescription']);
export const propertySearchFormValueSelector = (state) =>
  state.getIn(['form', 'propertySearch']);
export const propertySearchFilterFormSelector = (state) =>
  state.getIn(['form', 'appraisalPropertySearch']);
export const propertyDetailFormSelector = (state) =>
  state.getIn(['form', 'appraisalPropertyDetail']);
export const propertyDropdownsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'dropdowns']);
export const propertyDropdownsSelectorJs = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'dropdowns', 'data'], Map({}))
    .toJS();
export const propertyNotesSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'notes']);
export const propertyTaxingUnitsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'taxingUnits']);
export const propertyAllTaxingUnitsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'allTaxingUnits']);
export const propertyValuationTypesSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'valuationTypes']);
export const propertyImprovementTypesSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'improvementTypes']);
export const propertyValuationsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'valuations']);
export const propertyValuationCurrentImprovementSelector = (state) =>
  state.getIn([
    'app',
    'appraisal',
    'property',
    'valuationWidgetState',
    'currentImprovement',
  ]);
export const propertyValuationCurrentValuationSelector = (state) =>
  state.getIn([
    'app',
    'appraisal',
    'property',
    'valuationWidgetState',
    'currentValuation',
  ]);
export const propertyValuationCurrentPValuationIdSelector = (state) =>
  state.getIn([
    'app',
    'appraisal',
    'property',
    'valuationWidgetState',
    'currentPValuationId',
  ]);
export const propertyImprovementsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'improvements']);
export const propertyNewImprovementSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'newImprovementId']);
export const propertyImprovementDetailsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'improvementDetails']);
export const propertyLandSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'land']);
export const propertyNewLandSeletor = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'newLandId']);
export const propertySubcomponentConfigSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'subcomponent']);
export const propertyOwnersSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'owners']);
export const propertyTaxOfficeIdentifierSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'taxOfficeIdentifier']);
export const propertyLandNotesSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'landNotes']);
export const propertyExemptionsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'pExemptions']);
export const propertyImprvAdjustmentsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'allImprvAdjustments']);
export const propertyLandAdjustmentsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'allLandAdjustments']);
export const propertyImprvDetailAdjustmentsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'allImprvDetailAdjustments']);
export const propertyImprvInfluencerSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'improvementInfluencer']);
export const propertyLandInfluencerSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'landInfluencer']);
export const propertyImprvDetailInfluencerSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'imprvDetailInfluencer']);
export const propertyImprvAdjustTypeSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'imprvAdjustTypes']);
export const propertyLandAdjustTypeSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'landAdjustTypes']);
export const propertyImprvDetailAdjustTypeSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'imprvDetailAdjustTypes']);
export const propertyImprovementDetailFeaturesSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'improvementDetailFeatures']);
export const propertyRecalculateSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'recalculate']);
export const propertyRecalculateStateSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'recalculate', 'state']);
export const propertySizeSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'size']);
export const propertyExemptionCardSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'exemptionCard']);
export const propertyValueSummarySelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'valueSummary']);
export const zestimateDataSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'zestimate']);
export const zPropertySelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'zProperty']);
export const zCompsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'zComps']);
export const zPropertyHeaderSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'zHeader']);

//applications
export const getApplications = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'applications', 'data']);

export const getApplicationById = (state, id) => {
  const applications = getApplications(state);

  return applications.find((app) => app.get('applicationID', '') === id);
};

export const getApplicationFiles = (state, id) =>
  getApplicationById(state, id).get('fileAttachment', List()).toJS();

export const getApplicationsState = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'applications', 'state']);
export const getApplicationCodefiles = (state) => {
  const codefiles = state
    .getIn(['app', 'appraisal', 'property', 'applications', 'codefiles'])
    .toJS();

  const result = {
    idType: codefiles.idType.map((x) => ({
      label: x.codeDescription,
      value: x.codeName,
    })),
    owners: codefiles.owners.map((x) => ({ label: x.name, value: x.ownerID })),
    status: codefiles.status.map((x) => ({
      label: x.codeDescription,
      value: x.codeName,
    })),
    type: codefiles.type.map((x) => ({
      label: x.codeDescription,
      value: x.codeName,
    })),
  };

  return result;
};

export const getExemptions = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'exemptions', 'data']);
export const getExemptionsState = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'exemptions', 'state']);
export const getExemptionCodefiles = (state) => {
  let codefiles = state.getIn([
    'app',
    'appraisal',
    'property',
    'exemptions',
    'codefiles',
  ]);
  if (codefiles) {
    codefiles = codefiles.toJS();
  } else {
    codefiles = [];
  }

  const offersDeferral = {};
  for (const code of codefiles.codes) {
    offersDeferral[code.exemptionCode] = code.offersDeferral;
  }
  const result = {
    codes: codefiles.codes.map((x) => ({
      label: `${x.exemptionCode} (${x.exemptionDesc})`,
      value: x.exemptionCode,
    })),
    years: codefiles.years.map((x) => ({ label: x, value: String(x) })),
    offersDeferral,
  };

  return result;
};

export const applicationRollCorrectionCodesSelector = (state) => {
  let codeConfiguration = state.getIn([
    'app',
    'appraisal',
    'property',
    'exemptions',
    'rollCorrectionCodes',
    'data',
  ]);
  if (codeConfiguration) {
    codeConfiguration = codeConfiguration.toJS();
  } else {
    codeConfiguration = {};
  }

  if (codeConfiguration.configurationDefinition) {
    return {
      rollCorrCode: codeConfiguration.configurationDefinition.rollCorrCode,
      rollCorrReason: codeConfiguration.configurationDefinition.rollCorrReason,
    };
  }
  return {};
};

export const applicationRollCorrectionCodesStateSelector = (state) =>
  state.getIn([
    'app',
    'appraisal',
    'property',
    'exemptions',
    'rollCorrectionCodes',
    'state',
  ]);

export const applicationPropertyListSelector = (state) => {
  return state.getIn([
    'app',
    'appraisal',
    'property',
    'exemptions',
    'propertyList',
    'data',
  ]);
};

// property search
export const searchSelectSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'select']).toJS();
export const searchConfigSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'config', 'data']).toJS();
export const searchResultsConfigSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'resultsConfig', 'data']).toJS();
export const isHistorySearchSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'results', 'isHistorySearch']);
export const searchResultsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'results', 'data']).toJS();
export const searchLastPayloadSelector = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'searchLastPayload', 'data'])
    .toJS();
export const searchFiltersSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'results', 'filters']).toJS();
export const searchSortModelSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'results', 'sortModel']).toJS();
export const searchFilterModelSelector = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'results', 'filterModel'])
    .toJS();
export const searchResultsStateSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'results']).toJS().state;
export const searchPaginationSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'pagination']).toJS();

// events widget
export const eventSearchValueSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'events', 'eventSearchValue']);
export const propertyEventsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'events']);

export const sortByGroupAndOrder = (a, b) =>
  a.group * 10 + a.order - (b.group * 10 + b.order);

export const searchFieldsSelector = createSelector(
  searchConfigSelector,
  (config) =>
    config
      .map((field) => ({
        ...field,
        code: field.code || null,
      }))
      .sort(sortByGroupAndOrder),
);

// property lookup modal
export const propertyLookupModalOpenSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'propertyLookupModal', 'open']);
export const propertyLookupModalModeSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'propertyLookupModal', 'mode']);
export const propertyLookupMarketLookupModeSelector = (state) =>
  state.getIn([
    'app',
    'appraisal',
    'property',
    'propertyLookupModal',
    'marketLookup',
  ]);
export const propertyLookupCurrentValuationModeSelector = (state) =>
  state.getIn([
    'app',
    'appraisal',
    'property',
    'propertyLookupModal',
    'currentValuation',
  ]);
export const propertyLookupModalSearchParamsSelector = (state) =>
  state
    .getIn([
      'app',
      'appraisal',
      'property',
      'propertyLookupModal',
      'searchParams',
    ])
    .toJS();
export const propertyLookupModalPrimarySearchFieldsSelector = (state) =>
  state
    .getIn([
      'app',
      'appraisal',
      'property',
      'propertyLookupModal',
      'primarySearchFields',
    ])
    .toJS();
export const propertyLookupModalPrimaryResultFieldsSelector = (state) =>
  state
    .getIn([
      'app',
      'appraisal',
      'property',
      'propertyLookupModal',
      'primaryResultFields',
    ])
    .toJS();
export const propertyLookupModalStateSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'propertyLookupModal', 'state']);
export const propertyLookupModalDataSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'propertyLookupModal', 'data']);
export const propertyLookupModalRecordCountSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'propertyLookupModal', 'count']);
export const propertyLookupModalSelectionSelector = (state) =>
  state.getIn([
    'app',
    'appraisal',
    'property',
    'propertyLookupModal',
    'selection',
  ]);
export const propertyLookupModalFutureYearSelector = (state) =>
  state.getIn([
    'app',
    'appraisal',
    'property',
    'propertyLookupModal',
    'futureYear',
  ]);
export const propertyLookupModalAddPropertyToSGSelector = (state) =>
  state.getIn([
    'app',
    'appraisal',
    'property',
    'propertyLookupModal',
    'addPropertyToSG',
  ]);
export const propertyLookupModalAddPropertyToBPSelector = (state) =>
  state.getIn([
    'app',
    'appraisal',
    'property',
    'propertyLookupModal',
    'addPropertyToBP',
  ]);

export const propertyMassCreateSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'massCreate']);

export const propertyMassCreatePrepDataSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'massCreatePrepData']);

export const properyMassCreateSettingsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'massCreateSettings']);

export const properyMassCreateSettingSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'massCreateSetting']);

export const propertyMassCreateSettingAvailPropTypesSelector = (state) =>
  state.getIn([
    'app',
    'appraisal',
    'property',
    'massCreateSettingsAvailPropTypes',
  ]);

export const propertyMassCreateMasterSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'createMassCreate']);

export const propertyMassCreatePropertiesSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'massCreateProperties']);

export const walkthroughSettingsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'walkthroughSettings']);

export const mergeWalkthroughPropertiesSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'mergeProperties']);

export const mergedPropertySelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'mergedProperty']);

export const splitPropertySelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'splitProperty']);

export const splitReasonsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'splitReasons']);

export const updateOwnershipPercentSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'updateOwnershipPercent']);

export const propertyInactiveReasonsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'propertyInactiveReasons']);

export const propertyInactivateSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'propertyInactivate']);

export const updateAcreageSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'updateAcreage']);

export const propertySingleCreateSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'singleCreate']);

export const propCreateSettingAvailPropTypesSelector = (state) =>
  state.getIn([
    'app',
    'appraisal',
    'property',
    'propCreateSettingsAvailPropTypes',
  ]);

export const propertyValuationsBppSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'valuationsBpp']);

export const personalDepreciationCategoryMethod = (state) =>
  state.getIn([
    'app',
    'appraisal',
    'property',
    'personalDepreciationCategoryMethod',
  ]);

export const propertyPersonalDetailsSummarySelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'personalDetailSummary']);

export const propertyAllPersonalDetailsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'allPersonalDetails']);

export const propertyPersonalDetailSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'personalDetail']);

export const propertyPersonalDetailTaxingUnits = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'personalDetailTaxingUnits']);

export const propertyRenditionsBppSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'renditionsBpp']);

export const propertyPrimaryOwnerDetailsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'primaryOwnerDetails']);

export const propertyPreviousYearBppSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'renditionWalkthruBpp']);

// application events
export const getApplicationEvents = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'applicationEvents', 'data']);

export const getApplicationTotalEvents = (state) =>
  state.getIn([
    'app',
    'appraisal',
    'property',
    'applicationEvents',
    'totalEvents',
  ]);

export const getApplicationEventsState = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'applicationEvents', 'state']);

export const getApplicationEventTypes = (state) =>
  state.getIn([
    'app',
    'appraisal',
    'property',
    'applicationEvents',
    'eventTypes',
  ]);

export const exemptionNotesSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'exemptionNotes']);

export const getYears = (state) =>
  state
    .getIn(
      ['app', 'appraisal', 'property', 'exemptions', 'codefiles', 'years'],
      List(),
    )
    .toJS();
export const pExemptionSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'pExemption', 'data']).toJS();
export const pExemptionStateSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'pExemption']).toJS().state;

export const allDistinctExemptionsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'allExemptions']);
export const currentApplicationOwnersSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'applicationOwners']);

export const pExemptionCodeInfoSelector = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'pExemption', 'codeInfo'])
    .toJS();

export const hsDetailsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'hsDetails', 'data']).toJS();

export const marketModifiersSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'marketModifiers']);

export const ownerNamesSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'ownerNames']);

export const taxablesSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'taxables']);

export const taxableDetailsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'taxableDetails']);

export const taxingUnitSplitBoundaryLinesSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'taxingunitsplitboundarylines']);

export const taxingUnitSegmentsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'taxingunitsegments']);

export const taxingUnitSegmentSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'taxingunitsegment']);

export const propertySmartGroupsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'propertySmartGroups']);

export const smartGroupSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'smartGroup']);

export const smartGroupPropertiesSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'smartGroupProperties']);

export const propertySmartGroupsFilesSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'files']);

export const getSmartGroupsFilesState = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'files', 'state']);

export const propertySmartGroupTypesSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'smartGroupTypes']);

export const propertySmartGroupsBySearchSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'smartGroupsBySearch']);

export const propertyInspectionsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'inspections']);

export const propertyReasonCodesSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'reasonCodes']);

export const propertyInspectionSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'inspection']);

export const getInspectionFilesState = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'inspectionFiles', 'state']);

export const propertyAppraisersSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'propertyAppraisers']);

export const propertyPrimaryAppraiserSelector = (state) =>
  state.getIn([
    'app',
    'appraisal',
    'property',
    'propertyPrimaryAppraiser',
    'data',
  ]);

export const getSmartGroup = createSelector(
  [smartGroupSelector],
  (smartGroupIm) =>
    smartGroupIm.get('data') ? smartGroupIm.get('data').toJS() : {},
);

export const getInspection = createSelector(
  [propertyInspectionSelector],
  (inspectionIm) =>
    inspectionIm.get('data') ? inspectionIm.get('data').toJS() : {},
);

export const propertyPrimaryImageSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'primaryImageUrl']);

export const propertyObjectEventsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'objectEvents']);

export const propertyAgentSummarySelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'agentSummary']);

export const getBuildingPermits = (state) =>
  state.getIn([...prefix, 'buildingPermits', 'data'], List([])).toJS();

export const getBuildingPermitsState = (state) =>
  state.getIn([...prefix, 'buildingPermits', 'state']);

export const propertyHsValueLimitationsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'hsValueLimitations']);

export const getBuildingPermitIssuerCodes = (state) =>
  state
    .getIn(
      [...prefix, 'buildingPermitCodefiles', 'issuerCodes', 'data'],
      List([]),
    )
    .toJS();

export const getBuildingPermitIssuerCodesState = (state) =>
  state.getIn([...prefix, 'buildingPermitCodefiles', 'issuerCodes', 'state']);

export const getBuildingPermitTypes = (state) =>
  state
    .getIn([...prefix, 'buildingPermitCodefiles', 'types', 'data'], List([]))
    .toJS();

export const getBuildingPermitTypesState = (state) =>
  state.getIn([...prefix, 'buildingPermitCodefiles', 'types', 'state']);

export const getBuildingPermitSubTypes = (state) =>
  state
    .getIn([...prefix, 'buildingPermitCodefiles', 'subTypes', 'data'], List([]))
    .toJS();

export const getBuildingPermitSubTypesState = (state) =>
  state.getIn([...prefix, 'buildingPermitCodefiles', 'subTypes', 'state']);

export const getBuildingPermitStatus = (state) =>
  state
    .getIn([...prefix, 'buildingPermitCodefiles', 'status', 'data'], List([]))
    .toJS();

export const getBuildingPermitStatusState = (state) =>
  state.getIn([...prefix, 'buildingPermitCodefiles', 'status', 'state']);

export const getBuildingPermitCADStatus = (state) =>
  state
    .getIn(
      [...prefix, 'buildingPermitCodefiles', 'CADStatus', 'data'],
      List([]),
    )
    .toJS();

export const getBuildingPermitCADStatusState = (state) =>
  state.getIn([...prefix, 'buildingPermitCodefiles', 'CADStatus', 'state']);

export const getBuildingPermitPropertyCategories = (state) =>
  state
    .getIn(
      [...prefix, 'buildingPermitCodefiles', 'propertyCategories', 'data'],
      List([]),
    )
    .toJS();

export const getBuildingPermitPropertyCategoriesState = (state) =>
  state.getIn([
    ...prefix,
    'buildingPermitCodefiles',
    'propertyCategories',
    'state',
  ]);

export const getBuildingPermit = (state) =>
  state.getIn([...prefix, 'buildingPermit', 'data'], {}).toJS();

export const getBuildingPermitState = (state) =>
  state.getIn([...prefix, 'buildingPermit', 'state']);

export const getBuildingPermitProperties = (state) =>
  state.getIn([...prefix, 'buildingPermitProperties', 'data'], List([])).toJS();

export const getBuildingPermitPropertiesState = (state) =>
  state.getIn([...prefix, 'buildingPermitProperties', 'state']);

export const getABuildingPermitFilesState = (state) =>
  state.getIn([...prefix, 'buildingPermitFiles', 'state']);

export const getLastAppraisal = (state) =>
  state.getIn([...prefix, 'lastAppraisal', 'data']).toJS();

export const getLastAppraisalState = (state) =>
  state.getIn([...prefix, 'lastAppraisal', 'state']);

export const bppDetailFileListSelector = (state) =>
  state.getIn([...prefix, 'bppDetailFileList', 'data']).toJS();

export const bppDetailFileListStateSelector = (state) =>
  state.getIn([...prefix, 'bppDetailFileList']).toJS().state;

export const bppDetailFileSelector = (state) =>
  state.getIn([...prefix, 'fileBppDetail']).toJS();

export const getPropertyTags = (state) =>
  state.getIn([...prefix, 'propertyTags', 'data'], List([])).toJS();

export const getPropertyTagsState = (state) =>
  state.getIn([...prefix, 'propertyTags', 'state']);

export const getCodefilePropertyTags = (state) =>
  state.getIn([...prefix, 'codeFilePropertyTags', 'data'], List([])).toJS();

export const getCodefilePropertyTagsByYear = (state) =>
  state.getIn([...prefix, 'codeFilePropertyTagsByYear']).toJS();

export const propertyLinksSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'propertyLinks']);

export const getRecalculationJob = (state) =>
  state.getIn([...prefix, 'recalculationJob', 'data'], {}).toJS();

export const getAccountStatus = (state) =>
  state.getIn([...prefix, 'accountStatus', 'data']);

export const getRollHistory = (state) =>
  state.getIn([...prefix, 'rollHistory', 'data'], {}).toJS();

export const getAppraisalNoticeHistory = (state) =>
  state.getIn([...prefix, 'appraisalNoticeHistory', 'data'], {}).toJS();

export const getAppraisalNoticeHistoryState = (state) =>
  state.getIn([...prefix, 'appraisalNoticeHistory', 'state'], {});

export const propertyTaxDeferralSelector = (state) =>
  state.getIn([...prefix, 'taxDeferral', 'data'], {}).toJS();

export const propertyTaxDeferralStateSelector = (state) =>
  state.getIn([...prefix, 'taxDeferral', 'state'], {});

export const getOwnerSitus = (state) =>
  state
    .getIn([...prefix, 'currentImprovements', 'data', 'ownerSitus'], [])
    .toJS();

export const getOwnerImprovements = (state) =>
  state
    .getIn([...prefix, 'currentImprovements', 'data', 'improvements'], [])
    .toJS();

export const getCurrentImprovementsState = (state) =>
  state.getIn([...prefix, 'currentImprovements', 'state']);

export const getLandsOwnerSitus = (state) =>
  state.getIn([...prefix, 'currentLands', 'data', 'ownerSitus'], []).toJS();

export const getOwnerLands = (state) =>
  state.getIn([...prefix, 'currentLands', 'data', 'lands'], []).toJS();

export const getCurrentLandsState = (state) =>
  state.getIn([...prefix, 'currentLands', 'state']);

export const getOpenRollCorrections = (state) =>
  state.getIn([...prefix, 'openRollCorrections'], {}).toJS();

export const propertyRollCorrSelector = (state) =>
  state.getIn([...prefix, 'propertyRollCorrection'], {}).toJS();

export const getPropertyNotesState = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'notes', 'state']);

export const getPropertyPlats = (state) =>
  state.getIn([...prefix, 'plats', 'data'], List([])).toJS();

export const getPropertyPlatsState = (state) =>
  state.getIn([...prefix, 'plats', 'state']);

export const getPropertyAsCodeDropdownsState = (state) =>
  state.getIn([...prefix, 'dropdowns', 'state', 'asCode']);

export const getJanOneOwner = (state) =>
  state.getIn([...prefix, 'janOneOwner', 'data'], List([])).toJS();

export const getJanOneOwnerState = (state) =>
  state.getIn([...prefix, 'janOneOwner', 'state']);

export const getCalculationRules = (state) =>
  state.getIn([...prefix, 'calculationRules', 'data'], List([])).toJS();

export const getAllocationFactors = (state) =>
  state.getIn([...prefix, 'allocationFactors', 'data'], List([])).toJS();

export const getAllocationFactorsState = (state) =>
  state.getIn([...prefix, 'allocationFactors', 'state']);

export const getTaxingUnitLookup = (state) =>
  state
    .getIn([...prefix, 'taxingUnitLookup', 'data', 'taxingUnits'], List([]))
    .toJS();

export const getTaxingUnitLookupState = (state) =>
  state.getIn([...prefix, 'taxingUnitLookup', 'state']);

export const getPropertyForSIT = (state) =>
  state.getIn([...prefix, 'propertyForSit', 'data'], {}).toJS();

export const getPropertyForSITState = (state) =>
  state.getIn([...prefix, 'propertyForSit', 'state']);

export const getSitDetails = (state) =>
  state.getIn([...prefix, 'sitDetails', 'data'], List([])).toJS();

export const getSitDetailsState = (state) =>
  state.getIn([...prefix, 'sitDetails', 'state']);

export const getSit = (state) =>
  state.getIn([...prefix, 'sit', 'data'], {}).toJS();

export const getSitState = (state) => state.getIn([...prefix, 'sit', 'state']);

export const getSitDetail = (state) =>
  state.getIn([...prefix, 'sitDetail', 'data'], {}).toJS();

export const getSitDetailState = (state) =>
  state.getIn([...prefix, 'sitDetail', 'state']);

export const getSitDetailFilesState = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'sitDetailFiles', 'state']);

export const getBppImportData = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'bppImport', 'data']).toJS();

export const getBppImportErrorsData = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'bppImportErrors', 'data'])
    .toJS();

export const getMarketApproachData = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'marketApproach', 'data'], Map({}))
    .toJS();

export const getMarketApproachState = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'marketApproach', 'state']);

export const getMarketApproachError = (state) =>
  state.getIn(
    ['app', 'appraisal', 'property', 'marketApproach', 'error'],
    Map({}),
  );

export const getMarketApproachCompImages = (state) =>
  state
    .getIn(
      ['app', 'appraisal', 'property', 'marketApproachCompImages', 'data'],
      List([]),
    )
    .toJS();

export const getEquityApproachData = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'equityApproach', 'data'], Map({}))
    .toJS();

export const getEquityApproachState = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'equityApproach', 'state']);

export const getEquityApproachError = (state) =>
  state.getIn(
    ['app', 'appraisal', 'property', 'equityApproach', 'error'],
    Map({}),
  );

export const getEquityApproachCompImages = (state) =>
  state
    .getIn(
      ['app', 'appraisal', 'property', 'equityApproachCompImages', 'data'],
      List([]),
    )
    .toJS();

export const getAppeals = (state) =>
  state.getIn([...prefix, 'appeals', 'data'], List([])).toJS();

export const getAppealsState = (state) =>
  state.getIn([...prefix, 'appeals', 'state']);

export const getMarketApproachSubjectData = (state) =>
  state
    .getIn(
      ['app', 'appraisal', 'property', 'marketApproachSubject', 'data'],
      Map({}),
    )
    .toJS();

export const getEquityApproachSubjectData = (state) =>
  state
    .getIn(
      ['app', 'appraisal', 'property', 'equityApproachSubject', 'data'],
      Map({}),
    )
    .toJS();

export const getMarketApproachTiersData = (state) =>
  state
    .getIn(
      ['app', 'appraisal', 'property', 'marketApproachTiers', 'data'],
      List([]),
    )
    .toJS();

export const getEquityApproachTiersData = (state) =>
  state
    .getIn(
      ['app', 'appraisal', 'property', 'equityApproachTiers', 'data'],
      List([]),
    )
    .toJS();

export const getMarketApproachManualSelectionData = (state) =>
  state
    .getIn(
      ['app', 'appraisal', 'property', 'marketApproachManualSelection', 'data'],
      List([]),
    )
    .toJS();

export const getEquityApproachManualSelectionData = (state) =>
  state
    .getIn(
      ['app', 'appraisal', 'property', 'equityApproachManualSelection', 'data'],
      List([]),
    )
    .toJS();

export const getMarketApproachManualSelectionState = (state) =>
  state.getIn([
    'app',
    'appraisal',
    'property',
    'marketApproachManualSelection',
    'state',
  ]);

export const getEquityApproachManualSelectionState = (state) =>
  state.getIn([
    'app',
    'appraisal',
    'property',
    'equityApproachManualSelection',
    'state',
  ]);

export const getPropertyEfileData = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'efile'], Map({}));

export const currentPropertyIsEditableSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'currentPropertyIsEditable']);

export const equityResultsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'equityResults', 'data']).toJS();
export const equityResultsStateSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'equityResults', 'state']);

export const propertyErrorsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'errors', 'data']).toJS();

export const backPropertySelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'backProperty']).toJS();

export const propertyEventBackOptionSelector = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'propertyEventBackOption'])
    .toJS();

export const groupOpenRollCorrectionsSelector = (state) =>
  state.getIn([...prefix, 'groupOpenRollCorrections'], {}).toJS();

export const propertySearchParamsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'searchParams', 'data']).toJS();
export const propertySearchParamsStateSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'searchParams']).toJS().state;

export const propertySearchParamSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'searchParam', 'data']).toJS();
export const propertySearchParamStateSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'searchParam']).toJS().state;
export const propertySearchFormDataSelector = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'propertySearchFormData'])
    .toJS();
export const propertyAppraisalCompaniesSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'appraisalCompanies']);
export const propertyAppraisalCompanyLastImportSelector = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'appraisalCompanyLastImport'])
    .toJS();
export const propertyWorkItemsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'workItems']);
export const lateRenditionPenaltySelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'lateRenditionPenalty']);
export const propertyCasesSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'propertyCases']);
export const bppSubDetailsSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'bppSubDetails', 'data']).toJS();
export const bppSubDetailsStateSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'bppSubDetails']).toJS().state;
export const selectedPersonalDetailIDSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'selectedPersonalDetailID']);
export const tirzSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'tirz']);
export const tirzTaxingUnitsSelector = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'tirzTaxingUnits', 'data'])
    .toJS();
export const tirzTaxingUnitsStateSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'tirzTaxingUnits']).toJS().state;

export const ptdSummaryStateCodesSelector = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'ptdSummary', 'stateCodes', 'data'])
    .toJS();
export const ptdSummaryStateCodesStateSelector = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'ptdSummary', 'stateCodes'])
    .toJS().state;
export const ptdSummaryAgSelector = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'ptdSummary', 'ag', 'data'])
    .toJS();
export const ptdSummaryAgStateSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'ptdSummary', 'ag']).toJS()
    .state;

export const openRollCorrectionGroupsSelector = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'openRollCorrectionGroups', 'data'])
    .toJS();
export const openRollCorrectionGroupsSelectorState = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'openRollCorrectionGroups'])
    .toJS().state;

export const imageGalleryOptionsSelector = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'imageGalleryOptions', 'data'])
    .toJS();
export const imageGalleryOptionsStateSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'imageGalleryOptions']).toJS()
    .state;

export const imageGalleryDataSelector = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'imageGalleryData', 'data'])
    .toJS();
export const imageGalleryDataStateSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'imageGalleryData']).toJS()
    .state;

export const futureVersionSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'futureVersion']).toJS();

export const publicPortalAssociatedUsersSelector = (state) =>
  state
    .getIn([
      'app',
      'appraisal',
      'property',
      'publicPortalAssociatedUsers',
      'data',
    ])
    .toJS();
export const publicPortalAssociatedUsersStateSelector = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'publicPortalAssociatedUsers'])
    .toJS().state;

export const propertyElectronicRequestsSelector = (state) =>
  state
    .getIn([
      'app',
      'appraisal',
      'property',
      'propertyElectronicRequests',
      'data',
    ])
    .toJS();
export const propertyElectronicRequestsStateSelector = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'propertyElectronicRequests'])
    .toJS().state;

export const propertyNoticesEfileSelector = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'propertyEfile', 'eFile', 'data'])
    .toJS();
export const propertyNoticesEfileStateSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'propertyEfile', 'eFile']).toJS()
    .state;

export const propertyNoticesEfilePublicUsersSelector = (state) =>
  state
    .getIn([
      'app',
      'appraisal',
      'property',
      'propertyEfile',
      'associatedUsers',
      'data',
    ])
    .toJS();
export const propertyNoticesEfilePublicUsersStateSelector = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'propertyEfile', 'associatedUsers'])
    .toJS().state;

export const propertyNoticesEfileHistorySelector = (state) =>
  state
    .getIn([
      'app',
      'appraisal',
      'property',
      'propertyEfile',
      'eFileHistory',
      'data',
    ])
    .toJS();
export const propertyNoticesEfileHistoryStateSelector = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'propertyEfile', 'eFileHistory'])
    .toJS().state;

export const timber78ValuesSelector = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'timber78Values', 'data'])
    .toJS();
export const timber78ValuesStateSelector = (state) =>
  state.getIn(['app', 'appraisal', 'property', 'timber78Values']).toJS().state;

export const impDetailManagerCharacteristicsSelector = (state) =>
  state
    .getIn([
      'app',
      'appraisal',
      'property',
      'impDetailManagerCharacteristics',
      'data',
    ])
    .toJS();
export const impDetailManagerCharacteristicsStateSelector = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'impDetailManagerCharacteristics'])
    .toJS().state;

export const impDetailManagerConditionsSelector = (state) =>
  state
    .getIn([
      'app',
      'appraisal',
      'property',
      'impDetailManagerConditions',
      'data',
    ])
    .toJS();
export const impDetailManagerConditionsStateSelector = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'impDetailManagerConditions'])
    .toJS().state;

export const impDetailManagerNewValueSelector = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'impDetailManagerNewValue', 'data'])
    .toJS();
export const impDetailManagerNewValueStateSelector = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'impDetailManagerNewValue'])
    .toJS().state;

export const impDetailManagerPricingModelSelector = (state) =>
  state
    .getIn([
      'app',
      'appraisal',
      'property',
      'impDetailManagerPricingModel',
      'data',
    ])
    .toJS();
export const impDetailManagerPricingModelStateSelector = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'impDetailManagerPricingModel'])
    .toJS().state;

export const impDetailManagerAdjustmentSelector = (state) =>
  state
    .getIn([
      'app',
      'appraisal',
      'property',
      'impDetailManagerAdjustment',
      'data',
    ])
    .toJS();
export const impDetailManagerAdjustmentStateSelector = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'impDetailManagerAdjustment'])
    .toJS().state;

export const propertiesMassUpdateMultiYearSelector = (state) =>
  state
    .getIn(['app', 'appraisal', 'property', 'propertiesMassUpdateMultiYear'])
    .toJS();

export const workItemsUpdatedSelector = (state) => {
  return state.getIn(['app', 'appraisal', 'property', 'workItemsUpdated']);
};
